/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Use_3_ValueInputs */

const en_svc_integration_use_3_value = /** @type {(inputs: Svc_Integration_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calls, emails and notes summarised and filed against the right contact.`)
};

const lv_svc_integration_use_3_value = /** @type {(inputs: Svc_Integration_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zvani, e-pasti un piezīmes tiek apkopoti un pievienoti īstajam kontaktam.`)
};

/**
* | output |
* | --- |
* | "Calls, emails and notes summarised and filed against the right contact." |
*
* @param {Svc_Integration_Use_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_use_3_value = /** @type {((inputs?: Svc_Integration_Use_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Use_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_use_3_value(inputs)
	return en_svc_integration_use_3_value(inputs)
});